import { Box } from '@mui/material';
import React from 'react';

import {
  LegacyFieldWrapper,
  LegacyFieldWrapperPropsFragment,
} from '~/legacy-components/LegacyForms';

import { useSxStyles } from './useStyles';

type Props = LegacyFieldWrapperPropsFragment & {
  fieldName: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label?: string }[];
  disabled?: boolean;
};

export const LegacyMultiCheckbox = (props: Props) => {
  const {
    value: selectedValue,
    onChange,
    options,
    fieldName,
    label,
    required,
    fieldError,
    highlightLabel,
    disabled,
  } = props;
  const sxStyles = useSxStyles();

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === selectedValue) {
      onChange('');
    } else {
      onChange(e.target.value);
    }
  };

  return (
    <LegacyFieldWrapper
      label={label}
      required={required}
      fieldError={fieldError}
      highlightLabel={highlightLabel}
    >
      <Box>
        {options.map(({ value: optionValue, label }) => {
          return (
            <Box sx={sxStyles.option} key={`gender-opt-${optionValue}`}>
              <Box component={'label'}>
                <Box
                  component={'input'}
                  id={optionValue}
                  name={fieldName}
                  type="checkBox"
                  sx={sxStyles.checkbox}
                  value={optionValue}
                  onChange={onInputChange}
                  checked={selectedValue === optionValue}
                  disabled={disabled}
                />
                {label}
              </Box>
            </Box>
          );
        })}
      </Box>
    </LegacyFieldWrapper>
  );
};
